import type { ReactNode } from "react";

interface Props {
  icon: string;
  title: string;
  hint: string;
  cta?: ReactNode;
}

export function TgEmpty({ icon, title, hint, cta }: Props) {
  return (
    <div
      style={{
        padding: "48px 24px",
        textAlign: "center",
        background: "#fff",
        border: "1px solid var(--color-border)",
        borderRadius: 14,
      }}
    >
      <div style={{ fontSize: 44, marginBottom: 10 }}>{icon}</div>
      <h3
        style={{
          fontSize: 14,
          fontWeight: 800,
          margin: 0,
          marginBottom: 6,
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontSize: 12,
          color: "var(--color-text-muted)",
          lineHeight: 1.5,
          margin: 0,
          marginBottom: cta ? 14 : 0,
        }}
      >
        {hint}
      </p>
      {cta}
    </div>
  );
}
